import { Component } from '@angular/core';
import { FiDataFieldViewBase } from '@fi-app/data-field/data-field-view/data-field-view-base';

@Component({
    selector: 'data-field-tags',
    templateUrl: './tags.component.html',
    standalone: false,
})
export class FiDataFieldViewTagsComponent extends FiDataFieldViewBase {
    get isNotEmpty() {
        return this.dataFieldObject.Tags && this.dataFieldObject.Tags.length > 0;
    }
}
